/**
 * @file Product Form Bundle
 * @description Main entry point for product form components
 * Loads all necessary modules for product form functionality
 */

// Import utility functions (will be used by components)
import * as ProductFormUtils from './product-form-utils.js';
import * as VariantMatcher from './variant-matcher.js';

// Import Web Components (auto-registers via customElements.define)
import './variant-selector.js';
import './purchase-type-selector.js';
import './price-display.js';
import './product-submit.js';
import './product-form.js';
import './product-carousel.js';

// Export utilities for external use if needed
export { ProductFormUtils, VariantMatcher };

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

/**
 * Initialize product form components
 */
function init() {
  console.log('Product Form: Components loaded');

  // Add global error handler for component errors
  window.addEventListener('error', (e) => {
    if (e.target && e.target.tagName && e.target.tagName.includes('-')) {
      console.error('Product Form Component Error:', e);
    }
  });

  // Dispatch ready event
  document.dispatchEvent(new CustomEvent('product-form:ready', {
    bubbles: true,
    composed: true
  }));
}
